import type { ApplicationValidationError } from '@festina/configuration-general-types/configuration'
import type { SetRequired } from '@festina-life/core'

import { enumDefinitionPath } from '../../system/paths'
import type { EnumDefinition } from '../../uiModels/enumLiterals/types'
import type { ValidationErrorWithLocation } from '../../uiModels/errors/types'
import { ConfigurationItemOperationsWithErrors } from './ConfigurationItemOperationsWithErrors'
import type { OperationsListVariant } from './types'

type Props = {
  errors: ValidationErrorWithLocation<ApplicationValidationError>[]
  operations: SetRequired<EnumDefinition, 'internalOperation'>[]
  variant: OperationsListVariant
}

export const EnumDefinitionOperationsWithErrors = ({
  errors,
  operations,
  variant,
}: Props) => (
  <ConfigurationItemOperationsWithErrors
    operations={operations}
    errors={errors}
    variant={variant}
    itemIdFromOperation={(operation) => operation.entity?.name ?? ''}
    link={{ type: 'enumDefinition', propertyPath: enumDefinitionPath }}
  />
)
